module.exports = __webpack_public_path__ + "img/con4.75a1cb70.png";